"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _LiveMarkdown = _interopRequireDefault(require("./LiveMarkdown"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _LiveMarkdown["default"];
exports["default"] = _default;